/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-10-12 15:58:24
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-10-15 09:31:08
 * @FilePath: \thatOpenTools\src\pages\ifcViewerDemo\Index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { useEffect, useRef } from "react";
import IfcViewer from "../../components/IfcViewer";

function IfcViewerDemo() {
  const ifcViewerRef = useRef<any>(null);
  useEffect(() => {
    console.log("ifcViewerRef", ifcViewerRef.current)
  }, [])
  return <IfcViewer ref={ifcViewerRef} />;
}

export default IfcViewerDemo;
